import {
  AdviseEngagement,
  AdviseSupplier,
  AdviseCustomer,
  EngagementStep,
  FeatureResponseState
} from '../../../../types/advise';

export interface ReportSettings {
  sections: Record<string, boolean>;
  theme?: {
    primary?: string;
    accent?: string;
  };
  feature_matrix?: {
    feature_column_pct?: number;
    supplier_min_in?: number;
    note_font_scale?: number;
    cell_padding_px?: number;
    matrix_font_px?: number;
    wrap?: boolean;
  };
  typography?: {
    base_scale?: number;
  };
  spacing?: {
    section_spacing_px?: number;
  };
}

export const DEFAULT_SECTIONS: Record<string, boolean> = {
  cover: true,
  discovery: true,
  feature_matrix: true,
  scoring: true,
  official_quotes: true,
  pricing: true,
  roi_analysis: true,
  footer: true
};

export const SECTION_OPTIONS = [
  { key: 'cover', label: 'Cover Page' },
  { key: 'discovery', label: 'Discovery Summary' },
  { key: 'feature_matrix', label: 'Feature Comparison Matrix' },
  { key: 'scoring', label: 'Scoring Criteria' },
  { key: 'official_quotes', label: 'Official Supplier Quotes' },
  { key: 'pricing', label: 'Price Comparison' },
  { key: 'roi_analysis', label: 'ROI Analysis' },
  { key: 'footer', label: 'Footer' }
];

export interface ReportData {
  engagement: AdviseEngagement;
  suppliers: AdviseSupplier[];
  customer: AdviseCustomer | null;
  date: string;
  executiveSummary: string;
  featureComparison: FeatureComparisonRow[];
  detailedPricing: Record<string, Record<string, { monthly: number; oneTime: number }>>;
  roiAnalysis: Record<string, unknown>;
  settings: ReportSettings;
  // Required, so every report is built knowing which steps are turned off.
  steps: EngagementStep[];
}

export interface FeatureComparisonCell {
  state: FeatureResponseState | null;
  note?: string;
}

export interface FeatureComparisonRow {
  feature: string;
  [supplierId: string]: FeatureComparisonCell | string;
}

export interface ReportGeneratorProps {
  engagement: AdviseEngagement;
  suppliers: AdviseSupplier[];
  customer: AdviseCustomer | null;
  open: boolean;
  onClose: () => void;
}

export interface ReportLayoutEditorProps {
  settings: ReportSettings;
  onChange: (settings: ReportSettings) => void;
  // Sections a turned-off step removes, which the report leaves out whatever is chosen here.
  withheldSections?: Record<string, boolean>;
}

export interface ProfessionalReportPreviewProps {
  reportData: ReportData;
  onClose: () => void;
}
